import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/slider-arrow-right-icon.svg'
import _imports_1 from '@/assets/icons/slider-arrow-left-icon.svg'


const _hoisted_1 = { class: "content-image-slider" }
const _hoisted_2 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode($setup["Carousel"], {
        itemsToShow: 1,
        transition: 200,
        wrapAround: false,
        "mouse-drag": false,
        "touch-drag": false
      }, {
        addons: _withCtx(() => [
          ($setup.getSliderNavigation)
            ? (_openBlock(), _createBlock($setup["Navigation"], { key: 0 }, {
                next: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("img", { src: _imports_0 }, null, -1)
                ]))]),
                prev: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("img", { src: _imports_1 }, null, -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.sliderImages, (slide) => {
            return (_openBlock(), _createBlock($setup["Slide"], { key: slide }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "house-features"),
                (!$setup.props.isReviewQuote)
                  ? (_openBlock(), _createElementBlock("img", {
                      class: _normalizeClass(["carousel__item", { 'cursor-grab': $setup.getSliderNavigation, isBuilderQuoteView: $props.isBuilderQuoteView }]),
                      key: slide,
                      src: slide,
                      onClick: ($event: any) => ($setup.onSelectImage(slide))
                    }, null, 10, _hoisted_2))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 3
      })
    ]),
    _createVNode($setup["BuilderLightboxImages"], {
      isOpen: $setup.isImageModalOpen,
      imageUrl: $setup.selectedImageUrl,
      zoom: $setup.zoom,
      onUpdateZoom: $setup.updateZoom,
      onClose: $setup.closeImageModal
    }, null, 8, ["isOpen", "imageUrl", "zoom"])
  ], 64))
}